// Shim re-export to preserve existing import path
// The config command has been folderized under ./config/
export { configCommand } from "./config/index.js";
